import { combineReducers } from 'redux';
import storage from './storage';

export default combineReducers({
  storage,
});



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/redux/reducers/hosts/index.js